var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLuggage = function SvgLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.5 18.334v-1.667m5 1.667v-1.667m.492-12.5V2.5a.833.833 0 0 0-.833-.833H7.842a.833.833 0 0 0-.833.833v1.667m.658 12.5h4.667a5.75 5.75 0 0 0 2.308-.225c.407-.196.74-.517.95-.917a4.85 4.85 0 0 0 .242-2.191V7.5a4.85 4.85 0 0 0-.242-2.191c-.21-.4-.543-.721-.95-.917a5.75 5.75 0 0 0-2.308-.225H7.667a5.75 5.75 0 0 0-2.308.225c-.407.196-.74.517-.95.917A4.85 4.85 0 0 0 4.167 7.5v5.834a4.85 4.85 0 0 0 .242 2.191c.21.4.543.721.95.917a5.75 5.75 0 0 0 2.308.225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.334 7.5v5.833M11.666 7.5v5.833"
  })));
};
export default SvgLuggage;